module.exports = __webpack_public_path__ + "img/horizontal_3_5_r_7042.ddd0a72b.png";